var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOpenLockRed = function SvgOpenLockRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89806 6.21865H15.1443C15.3002 6.21865 15.4264 6.34667 15.4264 6.50488V13.6604C15.4264 14.2919 14.9203 14.8053 14.2981 14.8053H6.4C5.77771 14.8053 5.2717 14.2919 5.2717 13.6604V6.50488C5.2717 6.34667 5.39786 6.21865 5.55378 6.21865H6.20561L6.20561 5.07375C6.18354 4.66368 6.02645 4.0333 5.62112 3.5377C5.20794 3.07503 4.61134 2.78398 3.94903 2.78398C2.75437 2.78398 1.77354 3.73091 1.69722 4.9239C1.69405 4.97345 1.69244 6.09008 1.69244 6.14042H0C0 6.09025 0.000912731 4.97363 0.00272319 4.9239C0.0806515 2.78352 1.82093 1.06665 3.94903 1.06665C6.12657 1.06665 7.89806 2.86422 7.89806 5.07375V6.21865Z",
    fill: "#FF3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1233 12.4201C11.1767 12.3594 11.2023 12.2784 11.1935 12.1976L11.0156 10.5739C11.3045 10.3607 11.4773 10.0233 11.4773 9.6532C11.4773 9.02176 10.9712 8.5083 10.3489 8.5083C9.72666 8.5083 9.22064 9.02178 9.22064 9.6532C9.22064 10.0233 9.39335 10.3607 9.68231 10.5739L9.50436 12.1976C9.49553 12.2784 9.52116 12.3595 9.5746 12.4201C9.62805 12.4808 9.70463 12.5154 9.78478 12.5154H10.9131C10.9932 12.5154 11.0698 12.4808 11.1233 12.4201Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOpenLockRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/open_lock_red.990137a3.svg";
export { ForwardRef as ReactComponent };